import { addBronsonClasses } from './DacBronson';
import './xs2a.css';
import { Route } from '../../common/Navigation';

const xs2a = (window as any).xs2a;

export function initializeWizard(getDacCreditResult: Function, history: any) {
  registerAccountCheckCallbacks(getDacCreditResult, history);
  xs2a.init();
}

function registerAccountCheckCallbacks(
  getDacCreditResult: Function,
  history: any
) {
  xs2a.finish(() => {
    onAccountCheckFinished(getDacCreditResult);
  });
  xs2a.error((errorCode: string, messages: any, recoverable: boolean) => {
    onAccountCheckError(errorCode, messages, recoverable, history);
  });
  xs2a.abort(() => {
    onAccountCheckAbortion(history);
  });
  xs2a.render(() => {
    onRender();
  });
}

function onAccountCheckFinished(getDacCreditResult: Function) {
  getDacCreditResult();
}

function onAccountCheckError(
  errorCode: string,
  messages: any,
  recoverable: boolean,
  history: any
) {
  console.error(errorCode + ': ' + messages);
  // recoverable indicates whether the error results in an abortion of the transaction.
  // if recoverableequals falsethe transaction is aborted.
  if (!recoverable) {
    redirectToManualPage(history);
  }
}

function onAccountCheckAbortion(history: any) {
  console.log('aborted...');
  redirectToManualPage(history);
}

function onRender() {
  addBronsonClasses();
}

function redirectToManualPage(history: any) {
  history.push(Route.AdditionalAppFormDacError);
}
